export const KYC_APPROVED_EVENTS = {
  VIEW_KYC_APPROVED: 'view_kycapproved',
  SELECT_ONBOARDING_CREATE_TEEN_ACCOUNT:
    'select_onboarding_create_teen_account',
} as const;
